module.exports = __webpack_public_path__ + "img/tension-icon.3fde2475.png";